module.exports = __webpack_public_path__ + "static/img/fly-by-fire-lucre-games-thumbnail.9b743e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-thumbnail.jpg
// module id = WPxt
// module chunks = 0